<div class="row">

</div>
<div class="row mb-4">
    <div class="col-12 mb-4">
        <div class="card card-custom">
            <div class="card-body">
                <div class="my-card-title-with-tools">
                    <div class="title">
                        <span class="svg-icon svg-icon-primary svg-icon-2x mr-5">
                            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                    <rect x="0" y="0" width="24" height="24"/>
                                    <path d="M18,2 L20,2 C21.6568542,2 23,3.34314575 23,5 L23,19 C23,20.6568542 21.6568542,22 20,22 L18,22 L18,2 Z" fill="#000000" opacity="0.3"/>
                                    <path d="M5,2 L17,2 C18.6568542,2 20,3.34314575 20,5 L20,19 C20,20.6568542 18.6568542,22 17,22 L5,22 C4.44771525,22 4,21.5522847 4,21 L4,3 C4,2.44771525 4.44771525,2 5,2 Z M12,11 C13.1045695,11 14,10.1045695 14,9 C14,7.8954305 13.1045695,7 12,7 C10.8954305,7 10,7.8954305 10,9 C10,10.1045695 10.8954305,11 12,11 Z M7.00036205,16.4995035 C6.98863236,16.6619875 7.26484009,17 7.4041679,17 C11.463736,17 14.5228466,17 16.5815,17 C16.9988413,17 17.0053266,16.6221713 16.9988413,16.5 C16.8360465,13.4332455 14.6506758,12 11.9907452,12 C9.36772908,12 7.21569918,13.5165724 7.00036205,16.4995035 Z" fill="#000000"/>
                                </g>
                            </svg>
                        </span>
                        <h5>Whmcs Clients</h5>
                    </div>
                    <div class="tools">
                        <button color="warn" mat-button (click)="syncWhmcsClients()">
                            Sync with Whmcs
                        </button>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 text-right" [formGroup]="clientSettingsForm">
                        <mat-form-field>
                            <mat-select placeholder="Client status" formControlName="clientStatus" (selectionChange)="getWhmcsClients()">
                                <mat-option *ngFor="let status of statuses" [value]="status.value">
                                    {{ status.viewValue }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>
                <mat-progress-bar mode="indeterminate" *ngIf="(loadingWhmcsClients$ | async)"></mat-progress-bar>
                <div *ngIf="!(loadingWhmcsClients$ | async) &&!(hasClients$ | async)">No clients found!</div>
                <div *ngIf="!(loadingWhmcsClients$ | async) && (hasClients$ | async)" class="table-responsive">
                    <table class="table text-center">
                        <thead>
                        <tr>
                            <th scope="col">Id</th>
                            <th scope="col">Last name</th>
                            <th scope="col">First name</th>
                            <th scope="col">Email</th>
                            <th scope="col">Company</th>
                            <th scope="col">Active</th>
                            <th scope="col">Actions</th>
                        </tr>
                        </thead>
                        <tbody>
                        <ng-container *ngFor="let sms of clients$ | async">
                            <ng-container [ngTemplateOutlet]="RecentActivityItemTemplate" [ngTemplateOutletContext]="{item: sms}"></ng-container>
                        </ng-container>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>

<ng-template #RecentActivityItemTemplate let-item="item">
    <tr>
        <td nowrap class="table-row">{{item.id}}</td>
        <td nowrap class="table-row">{{item.lastname | maxCharacters: 30}}</td>
        <td nowrap class="table-row">{{item.firstname | maxCharacters: 30}}</td>
        <td nowrap class="table-row">{{item.email}}</td>
        <td nowrap class="table-row">{{item.companyname | maxCharacters: 30}}</td>
        <td class="table-row">
            <span class="label label-lg label-dot label-{{item.active ? 'success' : 'danger'}}"></span>
        </td>
        <td nowrap class="table-row">
            <button mat-icon-button color="primary" (click)="getClientPhonenumberForSMS(item)">
                <mat-icon aria-label="SMS">chat_bubble</mat-icon>
            </button>
            <button mat-icon-button color="accent">
                <mat-icon aria-label="More information">
                    <a href="mailto:{{item.email}}">alternate_email</a>
                    </mat-icon>
            </button>
            <button mat-icon-button (click)="getClientDetails(item)">
                <mat-icon aria-label="More information">notes</mat-icon>
            </button>
        </td>
    </tr>
</ng-template>